import {
    ArchiveTrackedEventTypeCommand,
    CanDeletePhysicalTargetTypeResponse,
    CanDeleteTaskTypeResponse,
    CreatePhysicalTargetTypeCommand,
    CreateTaskTypeCommand,
    CreateTrackedEventTypeCommand,
    ExportResponse, GetDailyReportQueryResult,
    GetKeyPhysicalTargetsForDepartmentWeekQueryResult,
    GetWeekHasExistingKeyPhysicalTargetsQueryResponse,
    KeyPhysicalTargetsImportViewModel,
    KeyPhysicalType,
    PhysicalTargetTypeViewModel,
    ReportingMonthsImportViewModel,
    ReportingMonthYearViewModel,
    RestoreTrackedEventTypeFromArchiveCommand,
    TaskType,
    TrackedEventTypeViewModel,
    UpdateDailyReportCommand,
    UpdatePhysicalTargetTypeCommand,
    UpdateTaskTypeCommand,
    UpdateTrackedEventTypeCommand,
    UploadResponseViewModel,
    WeekViewModel
} from '@/models/api';
import AppHttp from '@/lib/AppHttp';

export class Reporting {
    private resource: string = 'Reports';

    public async generateDailyReport(departmentId: string, date: string) {
        const response = await AppHttp.post(`${this.resource}/${departmentId}/Daily/${date}/Generate`, null);
        const data = response ? response.data : [];
        return data;
    }

    public async regenerateDailyReport(departmentId: string, date: string) {
        const response = await AppHttp.post(`${this.resource}/${departmentId}/Daily/${date}/Regenerate`, null);
        const data = response ? response.data : [];
        return data;
    }

    public async getDailyReport(departmentId: string, date: string ): Promise<GetDailyReportQueryResult> {
        const response = await AppHttp.get(`${this.resource}/${departmentId}/Daily/${date}`);
        const data = response ? response.data : null;
        return data;
    }

    public async updateDailyReport(departmentId: string, id: string, updateCommand: UpdateDailyReportCommand){
        const response = await AppHttp.put(`${this.resource}/${departmentId}/Daily/${id}`, updateCommand);
        const data = response ? response.data : null;
        return data;
    }

    public async markDailyReportAsApproved(departmentId: string, id: string) {
        const response = await AppHttp.put(`${this.resource}/${departmentId}/Daily/${id}/Approve`, null);
        const data = response ? response.data : null;
        return data;
    }

    public async markDailyReportAsNotApproved(departmentId: string, id: string) {
        const response = await AppHttp.put(`${this.resource}/${departmentId}/Daily/${id}/Approve/Unmark`, null);
        const data = response ? response.data : null;
        return data;
    }
}

export default new Reporting();
